var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShopCheck = function SvgShopCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.5C3 2.11929 4.11929 1 5.5 1H18.5C19.8807 1 21 2.11929 21 3.5V22C21 22.3466 20.8205 22.6684 20.5257 22.8507C20.2309 23.0329 19.8628 23.0494 19.5528 22.8944L18 22.118L16.4472 22.8944C16.1657 23.0352 15.8343 23.0352 15.5528 22.8944L14 22.118L12.4472 22.8944C12.1657 23.0352 11.8343 23.0352 11.5528 22.8944L10 22.118L8.44721 22.8944C8.16569 23.0352 7.83431 23.0352 7.55279 22.8944L6 22.118L4.44721 22.8944C4.13723 23.0494 3.76909 23.0329 3.47427 22.8507C3.17945 22.6684 3 22.3466 3 22V3.5ZM5.5 3C5.22386 3 5 3.22386 5 3.5V20.382L5.55279 20.1056C5.83431 19.9648 6.16569 19.9648 6.44721 20.1056L8 20.882L9.55279 20.1056C9.83431 19.9648 10.1657 19.9648 10.4472 20.1056L12 20.882L13.5528 20.1056C13.8343 19.9648 14.1657 19.9648 14.4472 20.1056L16 20.882L17.5528 20.1056C17.8343 19.9648 18.1657 19.9648 18.4472 20.1056L19 20.382V3.5C19 3.22386 18.7761 3 18.5 3H5.5Z",
    fill: "#576777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7C7.5 6.44772 7.94772 6 8.5 6H15.5C16.0523 6 16.5 6.44772 16.5 7C16.5 7.55228 16.0523 8 15.5 8H8.5C7.94772 8 7.5 7.55228 7.5 7Z",
    fill: "#576777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.5C7.5 9.94772 7.94772 9.5 8.5 9.5H15.5C16.0523 9.5 16.5 9.94772 16.5 10.5C16.5 11.0523 16.0523 11.5 15.5 11.5H8.5C7.94772 11.5 7.5 11.0523 7.5 10.5Z",
    fill: "#576777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14C7.5 13.4477 7.94772 13 8.5 13H12.5C13.0523 13 13.5 13.4477 13.5 14C13.5 14.5523 13.0523 15 12.5 15H8.5C7.94772 15 7.5 14.5523 7.5 14Z",
    fill: "#576777"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShopCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shop-check.4a166495.svg";
export { ForwardRef as ReactComponent };